import React, { Component } from 'react'

import './styles/style.css'

class Lines extends Component {

    render() {

        return (
            <div style={{opacity: this.props.opacity?this.props.opacity:1}} className="FullLines columns is-mobile">

                    <div className="FullLinesLineWrap column ColumnType2 is-mobile">
                        <div style={{borderColor: this.props.color}}className="FullLineBlue" />
                    </div>

                    <div className="FullLinesLineWrap column ColumnType1 is-mobile"></div>
                    
                    <div className="FullLinesLineWrap column ColumnType1 is-mobile">
                        <div style={{borderColor: this.props.color?this.props.color:'#fff'}}className="FullLineBlue" /> 
                    </div>

                    <div className="FullLinesLineWrap column ColumnType1 is-mobile"></div>

                    <div className="FullLinesLineWrap column ColumnType1 no-mobile no-tablet">
                        <div style={{borderColor: this.props.color?this.props.color:'#fff'}}className="FullLineBlue" /> 
                    </div>

                    <div className="FullLinesLineWrap column ColumnType1 no-mobile no-tablet"></div>

                    <div className="FullLinesLineWrap column ColumnType2 no-mobile">
                        <div style={{borderColor: this.props.color?this.props.color:'#fff'}}className="FullLineBlue" />
                    </div>

                    <div className="FullLinesLineWrap column ColumnType1 no-mobile"></div>
                    
                    <div className="FullLinesLineWrap column ColumnType1 no-mobile">
                        <div style={{borderColor: this.props.color?this.props.color:'#fff'}}className="FullLineBlue" /> 
                    </div>

                    <div className="FullLinesLineWrap column ColumnType1 no-mobile"></div>

                    <div className="FullLinesLineWrap column ColumnType1 no-mobile no-tablet">
                        <div style={{borderColor: this.props.color?this.props.color:'#fff'}}className="FullLineBlue" />   
                    </div>
                    
                    <div className="FullLinesLineWrap column ColumnType1 no-mobile no-tablet"></div>
                </div>
        )
    }
}

export default Lines


// WEBPACK FOOTER //
// ./src/Components/Lines/index.js